import { useState } from 'react';

export default function ReviewUsSection() {
  const [hoveredCard, setHoveredCard] = useState<string | null>(null);

  const reviewPlatforms = [
    {
      id: 'google',
      name: 'Google',
      icon: 'fab fa-google',
      iconColor: 'text-red-500',
      bgGradient: 'from-red-50 to-orange-50',
      hoverBorder: 'hover:border-red-400',
      rating: '4.9',
      reviewCount: '127+',
      url: 'https://g.page/r/CQnKz8vL2ZEEEBM/review',
      description: 'Share your experience on Google to help others find quality painters in Hertfordshire'
    },
    {
      id: 'trustpilot',
      name: 'Trustpilot',
      icon: 'fas fa-star',
      iconColor: 'text-green-500',
      bgGradient: 'from-green-50 to-emerald-50',
      hoverBorder: 'hover:border-green-400',
      rating: '4.8',
      reviewCount: '89+',
      url: 'https://www.trustpilot.com/evaluate/brushour.co.uk',
      description: 'Leave a Trustpilot review and help us maintain our excellent reputation'
    },
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'fab fa-facebook-f',
      iconColor: 'text-blue-600',
      bgGradient: 'from-blue-50 to-indigo-50',
      hoverBorder: 'hover:border-blue-400',
      rating: '4.9',
      reviewCount: '64+',
      url: 'https://www.facebook.com/brushour/reviews',
      description: 'Recommend us on Facebook and share your painting project experience with your community'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 bg-amber-50 text-amber-600 text-sm font-medium rounded-full mb-4">
            Your Feedback Matters
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Loved Our Service? <span className="text-amber-500">Review Us!</span>
          </h2>
          <p className="text-base text-slate-600 max-w-2xl mx-auto">
            Your reviews help other homeowners find trusted painters and decorators. We&apos;d be grateful if you could take a moment to share your experience.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {reviewPlatforms.map((platform) => (
            <a
              key={platform.id}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group relative p-8 bg-gradient-to-br ${platform.bgGradient} border-2 border-transparent ${platform.hoverBorder} rounded-2xl transition-all duration-300 cursor-pointer hover:shadow-lg hover:-translate-y-1`}
              onMouseEnter={() => setHoveredCard(platform.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-white shadow-sm`}>
                  <i className={`${platform.icon} text-2xl ${platform.iconColor}`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-slate-900 mb-1">
                    {platform.name}
                  </h3>
                  <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="fas fa-star text-sm text-amber-400"></i>
                      ))}
                    </div>
                    <span className="text-sm font-semibold text-slate-700">{platform.rating}</span>
                    <span className="text-sm text-slate-500">({platform.reviewCount} reviews)</span>
                  </div>
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {platform.description}
                  </p>
                </div>
              </div>

              <div className={`mt-6 flex items-center justify-center gap-2 py-3 bg-white rounded-lg font-medium text-slate-900 transition-all duration-300 ${hoveredCard === platform.id ? 'shadow-md' : ''}`}>
                <span>Write a Review</span>
                <i className={`fas fa-arrow-right text-sm transition-transform duration-300 ${hoveredCard === platform.id ? 'translate-x-1' : ''}`}></i>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-slate-50 rounded-full">
            <i className="fas fa-heart text-red-400"></i>
            <span className="text-sm text-slate-600">
              Thank you for supporting our family-run business!
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
